module.exports = __webpack_public_path__ + "img/profile-logo.5c92402e.svg";